import { useState } from 'react';

/**
 * Connection Status Badge Component
 * Shows the current connection status with appropriate icon and color
 */
export default function ConnectionStatusBadge({ status, error, onShowDetails }) {
  const [showDetails, setShowDetails] = useState(false);

  const statusConfig = {
    untested: {
      icon: '🔵',
      text: 'Not tested',
      color: 'bg-gray-100 text-gray-700 border-gray-300'
    },
    testing: {
      icon: '⏳',
      text: 'Testing...',
      color: 'bg-blue-100 text-blue-700 border-blue-300'
    },
    connected: {
      icon: '✅',
      text: 'Connected',
      color: 'bg-green-100 text-green-700 border-green-300'
    },
    failed: {
      icon: '❌',
      text: 'Connection failed',
      color: 'bg-red-100 text-red-700 border-red-300'
    },
    'saved-untested': {
      icon: '⚠️',
      text: 'Saved without testing',
      color: 'bg-yellow-100 text-yellow-700 border-yellow-300'
    }
  };

  const config = statusConfig[status] || statusConfig.untested;

  return (
    <div className="space-y-2">
      <div className={`inline-flex items-center gap-2 px-3 py-1 rounded-full border text-sm font-medium ${config.color}`}>
        <span>{config.icon}</span>
        <span>{config.text}</span>
        {status === 'failed' && error && (
          <button
            onClick={() => setShowDetails(!showDetails)}
            className="ml-1 text-xs underline hover:no-underline"
          >
            {showDetails ? 'Hide details' : 'Show details'}
          </button>
        )}
      </div>

      {showDetails && status === 'failed' && error && onShowDetails && (
        <div className="text-sm">
          {onShowDetails(error)}
        </div>
      )}
    </div>
  );
}